export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_08.5018949b.jpg";